import {
  ILovsTypes,
  IPaymentSimulationResponseData,
  IPaymentSimulationTableData,
  IPaymentTermsPopupFormState,
} from '.';
import { IAbstractRecord } from '@models';
import DateService from '@services/DateService';
import FormattingService from '@services/FormattingService';

export const getPaymentTermsPopupFormState =
  (): IPaymentTermsPopupFormState => ({
    values: {
      policyNumber: null,
      policyIssuanceDate: null,
      policyExpiryDate: null,
      paymentType: null,
      effectiveFrom: null,
      frequency: null,
      numOfPayments: null,
      bills: [],
    },
    errors: {
      policyIssuanceDate: null,
      policyExpiryDate: null,
      paymentType: null,
      effectiveFrom: null,
      frequency: null,
      numOfPayments: null,
      amountDue: null,
    },
    touched: {
      policyIssuanceDate: false,
      policyExpiryDate: false,
      paymentType: false,
      effectiveFrom: false,
      frequency: false,
      numOfPayments: false,
    },
  });

export const FREQUENCY_LOVS: Record<string, string> = {
  Month: 'Monthly',
  Quarter: 'Quarterly',
  SemiAnnual: 'Semesterly',
  Annual: 'Yearly',
};

export const frequencyArrayToList = (arr: string[]) => {
  const list: IAbstractRecord = {};

  arr.forEach((element: string) => {
    list[element] = FREQUENCY_LOVS[element];
  });

  return list;
};

export const numToList = (num: number) => {
  const list: IAbstractRecord = {};

  for (let i = 1; i <= num; i++) {
    list[i] = i;
  }

  return list;
};

export const mapToListingData = (
  data: Array<IPaymentSimulationResponseData>,
  lovs: ILovsTypes,
  currencySymbol: string
) => {
  const list: Record<string, IPaymentSimulationTableData> = {};

  data.forEach((obj: IPaymentSimulationResponseData, i: number) => {
    list[i] = {
      billNumber: obj.BillNumber,
      dueDate: obj.DueDate,
      totalPremium: obj.TotalPremium,
      commission: obj.Commission,
      taxOnCommission: obj.TaxOnCommission,
      amountDue: obj.AmountDue,
      outstandingAmount: obj.OutstandingBalance,
      status: obj.BillStatus,
      disabled: obj.BillStatus.toLowerCase() === 'paid',
      Currency: currencySymbol,
    };
  });

  // sort by due date (ascending)
  const sortedEntries = Object.entries(list)
    .sort(([, a], [, b]) => DateService.diff(a.dueDate, b.dueDate))
    .map(([key, value]) => [key, value]);

  const sortedList = Object.fromEntries(sortedEntries);

  return sortedList;
};
